module.exports = __webpack_public_path__ + "img/qrcode.17cfebb8.jpg";